<template>
    <div>
        <v-row dense>
            <span class="slide">
                Note* : File size should be less than {{ sizelimit / 1000000 }}MB! and File should be in
                <span v-for="(type, index) in allowed_extensions" in :key="index"> {{ type }}</span>
                Format!
            </span>
        </v-row>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Training Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"
            @current-items="getFiltered">

            <template v-slot:top>

                <v-toolbar flat dense color="white">
                    <label>Training Completed:- <b>{{ training_details }}</b></label>
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-6" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </v-col>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                    </v-text-field>
                    <span style="width: 20px;"></span>
                    <v-dialog v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on }">
                            <v-btn class="button" v-on="on" @click="conducted_attended = '2'; online_offline = '1'"
                                small>Add Training Details</v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="toolbar">
                                <span class="headline">{{ formTitle }} </span>
                            </v-card-title>
                            <br>
                            <v-row justify="center" dense>
                                <b>{{ training_dates }} For This Academicyear</b></v-row>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                            <v-autocomplete dense rounded outlined :items="ay_list" item-text="ay"
                                                item-value="id" v-model="ay" @change="get_training_dates_form_ay()"
                                                label="Academic Year1 *"
                                                placeholder="Select Academic Year"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                            <v-autocomplete dense rounded outlined :items="ay_list" item-text="ay"
                                                item-value="id" v-model="ay" label="Academic Year *"
                                                @change="get_training_dates_form_ay()"
                                                placeholder="Select Academic Year"></v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1"
                                            style="margin-top: -50px;">
                                            <!-- <span v-if="tenant == 'wws'"> -->
                                            <v-radio-group v-model="conducted_attended" row>
                                                <v-radio label="Attended" value="2"></v-radio>
                                                <v-radio label="Conducted" value="1"></v-radio>
                                            </v-radio-group>
                                            <!-- </span> -->
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1"
                                            style="margin-top: -50px;">
                                            <!-- <span v-if="tenant == 'wws'"> -->
                                            <v-radio-group v-model="conducted_attended" row>
                                                <v-radio label="Attended" value="Attended"></v-radio>
                                                <v-radio label="Conducted" value="Conducted"></v-radio>
                                            </v-radio-group>
                                            <!-- </span> -->
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1"
                                            style="margin-top: -50px;">
                                            <!-- <span v-if="tenant == 'wws'"> -->
                                            <v-radio-group v-model="online_offline" row>
                                                <v-radio label="Offline" value="1"></v-radio>
                                                <v-radio label="Online" value="2"></v-radio>
                                            </v-radio-group>
                                            <!-- </span> -->
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1"
                                            style="margin-top: -50px;">
                                            <!-- <span v-if="tenant == 'wws'"> -->
                                            <v-radio-group v-model="online_offline" row>
                                                <v-radio label="Offline" value="Offline"></v-radio>
                                                <v-radio label="Online" value="Online"></v-radio>
                                            </v-radio-group>
                                            <!-- </span> -->
                                        </v-col>





                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1"
                                            style="margin-top: -30px;">
                                            <v-textarea rows="2" clearable counter label="Title of Training Programme*"
                                                :rules="rules" outlined v-model="description"></v-textarea>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1"
                                            style="margin-top: -30px;">
                                            <v-textarea clearable rows="2" counter label="Title of Training Programme*"
                                                :rules="rules" outlined v-model="description"></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1"
                                            style="margin-top: -30px;">
                                            <span v-if="tenant == 'wws'">
                                                <v-textarea rows="2" clearable counter label="Training organization "
                                                    outlined v-model="training_org"></v-textarea>
                                            </span>
                                            <span v-else>
                                                <v-autocomplete dense rounded outlined :items="activity_type_list"
                                                    item-text="activitytype" item-value="activity_type_id"
                                                    v-model="activitytype" label="Training organization *"
                                                    placeholder="Select Training organization"></v-autocomplete>
                                            </span>
                                            <span v-if="tenant == 'sbpps'">
                                                <v-checkbox dense v-model="newcheckbox" color="success"
                                                    label="Training organization not present in above list ?"></v-checkbox>
                                            </span>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12"
                                            v-if="editedIndex == -1 && newcheckbox && tenant == 'sbpps'">
                                            <v-textarea rows="2" clearable counter label="Training organization "
                                                outlined v-model="training_org_other_for_sbpps"></v-textarea>
                                        </v-col>
                                        <v-col cols=" 12" sm="12" md="12" v-if="editedIndex != -1"
                                            style="margin-top: -30px;">
                                            <span v-if="tenant == 'wws'">
                                                <v-textarea clearable rows="2" counter label="Training organization "
                                                    outlined v-model="training_org"></v-textarea>
                                            </span>
                                            <span v-else>
                                                <v-autocomplete dense rounded outlined :items="activity_type_list"
                                                    item-text="activitytype" v-model="activitytype"
                                                    label="Training organization *"
                                                    placeholder="Select Training organization"></v-autocomplete>
                                            </span>

                                        </v-col>
                                        <!-- <span v-else> -->
                                        <!-- <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                            <v-autocomplete
                                                dense
                                                rounded
                                                outlined
                                                :items="activity_type_list"
                                                item-text="activitytype"
                                                item-value="activity_type_id"
                                                v-model="activitytype"
                                                label="Training organization *"
                                                placeholder="Select Training organization"
                                            ></v-autocomplete>
                                        </v-col> -->
                                        <!-- <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                            <v-autocomplete dense rounded outlined :items="activity_type_list" item-text="activitytype" v-model="activitytype" label="Training organization *" placeholder="Select Training organization"></v-autocomplete>
                                        </v-col>
                                         </span> -->

                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex == -1" style="margin-top: -30px;">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                                transition="scale-transition" offset-y full-width max-width="290px"
                                                min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field dense rounded v-model="dateFormatted"
                                                        label="From Date" hint="DD/MM/YYYY format" persistent-hint
                                                        outlined @blur="date2 = parseDate(dateFormatted)"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2" no-title
                                                    @input="menu2 = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex != -1" style="margin-top: -30px;">
                                            <v-menu ref="menu2_edit" v-model="menu2_edit"
                                                :close-on-content-click="false" transition="scale-transition" offset-y
                                                full-width max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field dense rounded v-model="dateFormatted_edit"
                                                        label="From Date" hint="DD/MM/YYYY format" persistent-hint
                                                        outlined @blur="date2_edit = parseDate(dateFormatted_edit)"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2_edit" no-title
                                                    @input="menu2_edit = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex == -1" style="margin-top: -30px;">
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                                transition="scale-transition" offset-y full-width max-width="290px"
                                                min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field dense rounded v-model="dateFormatted_end"
                                                        label="To Date" hint="DD/MM/YYYY format" persistent-hint
                                                        outlined @blur="date2_end = parseDate(dateFormatted_end)"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2_end" no-title
                                                    @input="menu1 = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex != -1" style="margin-top: -30px;">
                                            <v-menu ref="menu1_edit" v-model="menu1_edit"
                                                :close-on-content-click="false" transition="scale-transition" offset-y
                                                full-width max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <!-- <v-text-field
                                                        dense
                                                        rounded
                                                        v-model="edit_dateFormatted_end"
                                                        :rules="
                              edit_dateFormatted_end == null ||
                              edit_dateFormatted_end == ''
                                ? [' Date is required']
                                : []
                            "
                                                        label="To Date"
                                                        hint="DD/MM/YYYY format"
                                                        persistent-hint
                                                        outlined
                                                        @blur="
                              edit_date2_end = parseDate(
                                edit_dateFormatted_end
                              )
                            "
                                                        v-on="on"
                                                    ></v-text-field> -->
                                                    <v-text-field dense rounded v-model="edit_dateFormatted_end"
                                                        label="To Date" hint="DD/MM/YYYY format" persistent-hint
                                                        outlined
                                                        @blur="edit_date2_end = parseDate(edit_dateFormatted_end)"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="edit_date2_end" no-title
                                                    @input="menu1_edit = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>


                                        <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1"
                                            style="margin-top: -10px;">
                                            <v-text-field dense type="number" rounded outlined v-model="no_of_hr"
                                                label="No. of Hours"
                                                placeholder="Please enter No. of Hours"></v-text-field>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1"
                                            style="margin-top: -10px;">
                                            <v-text-field dense type="number" rounded outlined v-model="no_of_hr"
                                                label="No. of Hours"
                                                placeholder="Please enter No. of Hours"></v-text-field>
                                        </v-col>

                                        <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1"
                                            style="margin-top: -10px;">
                                            <v-text-field dense type="number" rounded outlined v-model="no_of_minutes"
                                                label="No. of Minutes"
                                                placeholder="Please enter No. of Minutes"></v-text-field>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1"
                                            style="margin-top: -10px;">
                                            <v-text-field dense type="number" rounded outlined v-model="no_of_minutes"
                                                label="No. of Minutes"
                                                placeholder="Please enter No. of Minutes"></v-text-field>
                                        </v-col>



                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex != -1 && activity_letter != 'NA'"
                                            style="margin-top: -20px;">
                                            Previous File :
                                            <a :href="aws_path + activity_letter" target="_blank"> View</a>
                                            <v-btn text title="Delete attachment" :loading="delete_load"
                                                @click="deleteAttachment()">Delete
                                                <v-icon color="red">mdi-window-close</v-icon>
                                            </v-btn>
                                        </v-col>

                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex == -1" style="margin-top: -20px;">
                                            <v-file-input rounded label="Training Certificate" outlined dense
                                                placeholder="Optional" v-model="activity_letter"
                                                @change="validateActivityLetter()" :hint="activity_letter == null
                                                    ? 'File should be in given format'
                                                    : 'File selected'
                                                    "></v-file-input>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6" v-if="editedIndex != -1" style="margin-top: -20px;">
                                            <v-file-input rounded label="Training Certificate" outlined dense
                                                placeholder="Optional" v-model="edit_activity_letter"
                                                @change="validateEditActivityLetter()" :hint="edit_activity_letter == null
                                                    ? 'File should be in given format'
                                                    : 'File selected'
                                                    "></v-file-input>
                                        </v-col>

                                        <!-- <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col> -->
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions style="margin-top: -50px;">
                                <v-spacer></v-spacer>
                                <v-btn class="button" @click="close">Cancel</v-btn>
                                <v-btn class="button" :disabled="!isFormValid" @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>

            <!-- <template v-slot:item.iscurrentjob="{ item }">
        <span v-if="item.iscurrentjob">
          <v-icon class="mr-2 v-icon-size" color="success"
            >mdi-check-circle-outline</v-icon
          >
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error"
            >mdi-close-circle-outline</v-icon
          >
        </span>
      </template> -->

            <template v-slot:item.activity_letter="{ item }">
                <span v-if="item.activity_letter != 'NA'">
                    <a :href="aws_path + item.activity_letter" target="_blank"> View </a>

                </span>
                <span v-else> NA </span>
            </template>

            <template v-slot:item.action="{ item }">
                <div>
                    <v-avatar style="" size="20" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                    </v-avatar>
                    <v-avatar style="" size="20" class="edit-avatar">
                        <v-icon color="error" class="delete-v-icon mr-2" @click="deleteItem(item)">delete</v-icon>
                    </v-avatar>
                </div>
            </template>

        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please wait..
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        instid: Number,
    },
    data() {
        return {
            training_details: "",
            training_dates: "",
            conducted_attended: '2',
            online_offline: '1',
            overlay: false,
            delete_load: false,
            dialog_upload: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            rules: [(v) => v.length <= 250 || "Max 250 characters"],
            errorMsg: {
                activitytype: false,
            },
            filters: {
                ay: [],

            },
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },

                {
                    text: "Training organization",
                    align: "left",
                    sortable: false,
                    value: "activitytype",
                },
                {
                    text: "Attended / Conducted",
                    align: "left",
                    sortable: false,
                    value: "conducted_attended",
                },
                {
                    text: "Online / Offline",
                    align: "left",
                    sortable: false,
                    value: "online_offline",
                },
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "ay",
                },
                {
                    text: "Title of Training Programme",
                    align: "left",
                    sortable: true,
                    value: "description",
                },
                {
                    text: "From Date",
                    align: "left",
                    sortable: true,
                    value: "date2",
                },
                {
                    text: "To Date",
                    align: "left",
                    sortable: true,
                    value: "date2_end",
                },
                {
                    text: "No. of Hours",
                    align: "left",
                    sortable: true,
                    value: "no_of_hr",
                },
                {
                    text: "No. of Minutes",
                    align: "left",
                    sortable: true,
                    value: "no_of_minutes",
                },
                {
                    text: "Documet",
                    align: "left",
                    value: "activity_letter",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            editedIndex: -1,
            instructor_activity_list: [],
            activity_type_list: [],
            activitytype: null,
            description: "",
            id: null,
            research_letter: null,
            edit_research_letter: null,
            aws_path: null,
            sizelimit: null,
            allowed_extensions: [],
            size_flag: false,
            ext_flag: false,
            menu2: false,
            menu2_edit: false,
            menu1: false,
            menu1_edit: false,
            display_size: null,
            dateFormatted_edit: "",
            dateFormatted: "",
            dateFormatted_end: "",
            edit_dateFormatted_end: "",
            date2: new Date().toISOString().substr(0, 10),
            date2_edit: "",
            date2_end: new Date().toISOString().substr(0, 10),
            edit_date2_end: "",
            ay_list: [],
            ay: null,
            training_org_other_for_sbpps: "",
            newcheckbox: false,
            no_of_hr: null, tenant: "", training_org: "", activity_letter: null, edit_activity_letter: null, no_of_minutes: null
        };
    },
    created() {
        this.conducted_attended = "2"
        this.online_offline = "1"
    },
    watch: {
        date2(val) {
            this.dateFormatted = this.formatDate(this.date2);
        },
        date2_end(val) {
            this.dateFormatted_end = this.formatDate(this.date2_end);
        },
        date2_edit(val) {
            this.dateFormatted_edit = this.formatDate(this.date2_edit);
        },
        edit_date2_end(val) {
            this.edit_dateFormatted_end = this.formatDate(this.edit_date2_end);
        },
        instid() {
            this.getData();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Training Details" : "Edit Training Details";
        },

        bookList1() {
            return this.instructor_activity_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },

        isFormValid() {
            if (this.tenant === "wws" && this.description && this.training_org) {
                return true;
            } else if (this.tenant === "sbpps" && this.description && this.training_org_other_for_sbpps) {
                return true;
            }
            else if (this.tenant != "wws" && this.tenant != "sbpps " && this.description && this.activitytype) {
                return true;
            }
            else {
                return false;
            }
        },
    },
    mounted() {
        this.conducted_attended = "2"
        this.online_offline = "1"
        this.getData();
        this.tenant = localStorage.getItem("EPS-tenant");
    },
    methods: {
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.instructor_activity_list.map((d) => d[val]);
        },
        deleteAttachment() {
            if (!confirm("Are you sure you want to delete..?"))
                return;
            this.delete_load = true;
            const data = {
                activity_letter: this.activity_letter,
                id: this.id,
            };
            axios
                .post("/EmployeeProfile/deleteActivityLetter", data)
                .then((res) => {
                    this.delete_load = false;
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Deleted successfully..."); // show snackbar on success
                        this.dialog = false;
                        this.getData();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar
                        //alert(res.data.status_reason)
                    }
                })
                .catch((error) => {
                    this.delete_load = false;
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.delete_load = false;
                });
        },
        getData() {
            const formData = {
                instid: this.instid,
            };
            axios
                .post("/EmployeeProfile/getEmployeeOther", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.instructor_activity_list = res.data.instructor_activity_list;
                        this.allowed_extensions = res.data.allowed_extensions;
                        this.sizelimit = res.data.sizelimit;
                        this.display_size = this.sizelimit / 1000;
                        this.aws_path = res.data.aws_path;
                        this.activity_type_list = res.data.activity_type_list;
                        this.ay_list = res.data.ay_list;
                        this.ay = res.data.cay;
                        this.training_dates = res.data.training_dates;
                        this.training_details = res.data.training_hours_completed
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    // this.comp_load = false;
                });
        },
        save_new_train_org() {
            const formData = {
                training_org_other_for_sbpps: this.training_org_other_for_sbpps,
            };

            axios.post("/EmployeeProfile/saveNewTrainingOrganization", formData)
                .then(res => {
                    if (res.data.status.code === "SUCCESS") {
                        this.showSnackbar("#4caf50", "Activity Type Added Successfully..."); // show snackbar on success

                    } else if (res.data.status.code === "NA") {
                        this.showSnackbar("#b71c1c", "Activity Type Already Present!!!"); // show snackbar on error
                    }
                })

        },

        get_training_dates_form_ay() {
            const formData = {
                ay: this.ay,
            };
            axios
                .post("/EmployeeProfile/get_training_dates_form_ay", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.training_dates = res.data.training_dates;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {

                });
        },
        validateActivityLetter() {
            let file1 = this.activity_letter;
            let file_size = file1.size;
            let file_name = this.activity_letter.name;
            let ext = file_name.split(".").pop();
            if (file_size > this.sizelimit) {
                this.size_flag = true;
                this.showSnackbar("#b71c1c", "File should be less than " + this.sizelimit / 1000000 + "MB!!!");
                this.activity_letter = null;
            } else {
                this.size_flag = false;
            }
            for (var i = 0; i < this.allowed_extensions.length; i++) {
                if (ext == this.allowed_extensions[i]) {
                    this.ext_flag = false;
                    return;
                }
            }
            for (var i = 0; i < this.allowed_extensions.length; i++) {
                if (ext != this.allowed_extensions[i]) {
                    this.ext_flag = true;
                    this.showSnackbar("#b71c1c", "File should be in " + this.allowed_extensions + " format!!!");
                    this.activity_letter = null;
                    return;
                }
            }
        },
        validateEditActivityLetter() {
            let file1 = this.edit_activity_letter;
            let file_size = file1.size;
            let file_name = this.edit_activity_letter.name;
            let ext = file_name.split(".").pop();
            if (file_size > this.sizelimit) {
                this.size_flag = true;
                this.showSnackbar("#b71c1c", "File should be less than " + this.sizelimit / 1000000 + "MB!!!");
                this.edit_activity_letter = null;
            } else {
                this.size_flag = false;
            }
            for (var i = 0; i < this.allowed_extensions.length; i++) {
                if (ext == this.allowed_extensions[i]) {
                    this.ext_flag = false;
                    return;
                }
            }
            for (var i = 0; i < this.allowed_extensions.length; i++) {
                if (ext != this.allowed_extensions[i]) {
                    this.ext_flag = true;
                    this.showSnackbar("#b71c1c", "File should be in " + this.allowed_extensions + " format!!!");
                    this.edit_activity_letter = null;
                    return;
                }
            }
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        editItem(item) {
            this.editedIndex = this.instructor_activity_list.indexOf(item);
            // this.editedItem = Object.assign({}, item);
            this.description = item.description;
            this.id = item.id;
            this.activity_letter = item.activity_letter;
            this.activitytype = item.activitytype;
            this.dateFormatted_edit = item.date2;
            this.edit_dateFormatted_end = item.date2_end;
            this.ay = item.ay_id
            this.no_of_hr = item.no_of_hr
            this.conducted_attended = item.conducted_attended
            this.online_offline = item.online_offline
            this.training_org = item.activitytype
            this.no_of_hr = item.no_of_hr
            this.no_of_minutes = item.no_of_minutes
            this.dialog = true;
        },
        isValidated() {
            if (this.activitytype) {
                return true;
            } else {
                if (!this.title) {
                    this.errorMsg.activitytype = true;
                }
                return false;
            }
        }, // .....end of isValidated()
        save() {
            if (this.editedIndex > -1) {
                // if (this.isValidated()) {
                if (this.description.length > 250) {
                    this.showSnackbar("#b71c1c", "Please enter Title in 250 characters!!!");
                    return false;
                }
                else if (this.description == null || this.description == '') {
                    this.showSnackbar("#b71c1c", "Please enter Title...");
                    return false;
                }
                //  else if (this.activitytype == null) {
                //     this.showSnackbar("#b71c1c", "Please select Activity type!!!");
                //     return false;
                // } 
                // else if (this.dateFormatted_edit == "" || this.dateFormatted_edit == null) {
                //     this.showSnackbar("#b71c1c", "Please select From Date!!!");
                //     return false;
                // } 
                // else if (this.edit_dateFormatted_end == "" || this.edit_dateFormatted_end == null) {
                //     this.showSnackbar("#b71c1c", "Please select To Date!!!");
                //     return false;
                // } 
                //      else if (this.edit_dateFormatted_end < this.dateFormatted_edit) {
                //       this.showSnackbar("red","Please Select End Date Greater Than Start Date...");
                //  }
                else if (this.no_of_hr < 0) {
                    this.showSnackbar("red", "Please Enter Number Of Hours Greater Than 0...");
                    return false;
                }
                else {
                    this.dialog_upload = true;
                    let formData = new FormData();
                    formData.append("instid", this.instid);
                    formData.append("description", this.description);
                    formData.append("training_org", this.training_org);
                    formData.append("conducted_attended", this.conducted_attended);
                    formData.append("online_offline", this.online_offline);
                    formData.append("id", this.id);
                    formData.append("activity_letter", this.edit_activity_letter);
                    formData.append("activitytype", this.activitytype);
                    formData.append("fromDate", this.dateFormatted_edit);
                    formData.append("toDate", this.edit_dateFormatted_end);
                    formData.append("ay", this.ay);
                    formData.append("no_of_hr", this.no_of_hr);
                    formData.append("no_of_minutes", this.no_of_minutes);

                    axios
                        .post("/EmployeeProfile/editEmployeeOther", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.status.code == "SUCCESS") {
                                    this.showSnackbar("#4caf50", "Other details updated successfully..."); // show snackbar on success
                                } else {
                                    this.showSnackbar("#b71c1c", "Other details already present!!!"); // show snackbar on success
                                }

                                this.getData();
                                this.dialog_upload = false;
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            this.description = "";
                            this.edit_activity_letter = null;
                            this.activitytype = null;
                            this.dateFormatted_edit = "";
                            this.edit_dateFormatted_end = "";
                            this.no_of_hr = null
                        });

                    this.close();
                }
            }
            // } 
            else {
                if (this.description.length > 250) {
                    this.showSnackbar("#b71c1c", "Please enter Title in 250 characters!!!");
                    return false;
                } else if (this.description == null || this.description == '') {
                    this.showSnackbar("#b71c1c", "Please enter Title...");
                    return false;
                }
                // else if (this.dateFormatted_end < this.dateFormatted) {
                //       this.showSnackbar("red","Please Select End Date Greater Than Start Date...");
                //        return false;
                //  }
                else if (this.no_of_hr < 0) {
                    this.showSnackbar("red", "Please Enter Number Of Hours Greater Than 0...");
                    return false;
                }
                // else if (this.activitytype == null) {
                //     this.showSnackbar("#b71c1c", "Please select Activity type!!!");
                //     return false;
                // } 
                // else if (this.dateFormatted == "" || this.dateFormatted == null) {
                //     this.showSnackbar("#b71c1c", "Please select From Date!!!");
                //     return false;
                // } else if (this.dateFormatted_end == "" || this.dateFormatted_edit == null) {
                //     this.showSnackbar("#b71c1c", "Please select To Date!!!");
                //     return false;
                // } 
                else {

                    if (this.newcheckbox === true && this.training_org_other_for_sbpps) {
                        this.save_new_train_org();
                    }
                    this.dialog_upload = true;
                    let formData = new FormData();
                    formData.append("instid", this.instid);
                    formData.append("description", this.description);
                    formData.append("training_org", this.training_org);
                    formData.append("conducted_attended", this.conducted_attended);
                    formData.append("online_offline", this.online_offline);
                    formData.append("id", this.id);
                    formData.append("activity_letter", this.activity_letter);
                    formData.append("activitytype", this.activitytype);
                    formData.append("fromDate", this.dateFormatted);
                    formData.append("toDate", this.dateFormatted_end);
                    formData.append("ay", this.ay);
                    formData.append("no_of_hr", this.no_of_hr);
                    formData.append("no_of_minutes", this.no_of_minutes);
                    formData.append("training_org_other_for_sbpps", this.training_org_other_for_sbpps);
                    formData.append("newcheckbox", this.newcheckbox);

                    axios
                        .post("/EmployeeProfile/saveEmployeeOther", formData)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Other details added successfully..."); // show snackbar on success
                                this.getData();

                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Other details already present!!!"); // show snackbar on error
                            }
                            this.dialog_upload = false;
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Someting went wrong!!!");
                            window.console.log(error);
                        })
                        .finally(() => {
                            this.description = "";
                            this.activity_letter = null;
                            this.activitytype = null;
                            this.dateFormatted = "";
                            this.dateFormatted_end = "";
                            this.no_of_hr = null
                        });

                    this.close();
                }
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        deleteItem(item) {
            // alert("in delete : " + item.id);
            var result = confirm("Want to delete?");
            if (result) {
                const formData = {
                    instid: this.instid,
                    inst_other_id: item.id,
                };
                axios
                    .post("/EmployeeProfile/deleteEmployeeOther", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Other details deleted successfully...");
                            } else {
                                this.showSnackbar("#b71c1c", "Can not delete Other details!!!");
                            }
                            this.getData();
                        } else {
                            this.showSnackbar("#b71c1c", "Please try again!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        // this.comp_load = false;
                    });
            }
        },
        close() {
            this.dialog = false;
            this.newcheckbox = false;
            this.description = "";
            this.training_org = "";
            this.conducted_attended = null;
            this.online_offline = null;
            this.activity_letter = null;
            this.edit_activity_letter = null;
            this.activitytype = null;
            this.date2 = null;
            this.date2_end = null;
            this.dateFormatted = "";
            this.dateFormatted_end = "";
            this.edit_dateFormatted_end = "";
            this.dateFormatted_edit = "";
            this.editedIndex = -1;
            // setTimeout(() => {
            //   this.editedItem = Object.assign({}, this.defaultItem);
            //   this.editedIndex = -1;
            // }, 300);
        },
    },
};
</script>
<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
}


</style>
